












































































import _ from 'lodash'
import { Vue, Component } from 'vue-property-decorator'
import runImport, { validTypes } from '@/util/import'
import StoreAPI from '@/util/api/StoreAPI'
import { Nullable, Maybe } from '@/types/general'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'
import runExport from '../../../../util/export'

/* eslint-disable indent */
@Component({
    name: 'import-export-panels',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class ImportExportPanels extends Vue {
    /**
     * Export format
     */
    format: string = 'vpx'

    /**
     * Vault ID to export from
     */
    exportVaultId: Nullable<string> = null

    /**
     * Possible import file types
     */
    fileTypes: string = validTypes().join(', ')

    /**
     * Vault ID to import into
     */
    importVaultId: Nullable<string> = null

    /**
     * File uploaded to import
     */
    importFile: Nullable<File> = null

    /**
     * Update vault to export from
     */
    updateExportVault(exportVaultId: string): void {
        this.exportVaultId = exportVaultId
    }

    /**
     * Update vault to import to
     */
    updateImportVault(importVaultId: string): void {
        this.importVaultId = importVaultId
    }

    /**
     * Export and download all entries under the vault selected
     */
    runExport(): void {
        runExport(this.exportVaultId || undefined)
    }

    setImportFile(file: Nullable<File>): void {
        this.importFile = file
    }

    async runImport(): Promise<void> {
        if (this.importFile === null) return
        await runImport(this.importFile, this.importVaultId || undefined)
        this.$success({ text: 'Import complete' })
    }
}
